__turbopack_context__.v({
  "actions": "home-module__txgM7a__actions",
  "card": "home-module__txgM7a__card",
  "cardHeader": "home-module__txgM7a__cardHeader",
  "container": "home-module__txgM7a__container",
  "footer": "home-module__txgM7a__footer",
  "formRow": "home-module__txgM7a__formRow",
  "grid": "home-module__txgM7a__grid",
  "header": "home-module__txgM7a__header",
  "item": "home-module__txgM7a__item",
  "list": "home-module__txgM7a__list",
  "main": "home-module__txgM7a__main",
  "meta": "home-module__txgM7a__meta",
  "muted": "home-module__txgM7a__muted",
  "row": "home-module__txgM7a__row",
  "section": "home-module__txgM7a__section",
  "subtitle": "home-module__txgM7a__subtitle",
  "title": "home-module__txgM7a__title",
});
